import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../../App.css';

import { AppBar, Box, Button, Toolbar, IconButton, Drawer, List, ListItem, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { LogTabEventToGA } from '../googleAnalytics/GoogleAnalytics';

import wiproLogo from '../../asset/images/wipro-logo-color.svg';
import { useMsal } from '@azure/msal-react';
import LogoutIcon from '@mui/icons-material/Logout';
import { useIsAdminQuery } from '../../data/api/endPointsSlice';
import {
  agentsTabClickedText,
  appsTabClickedText,
  drawerClosedText,
  drawerOpenedText,
  homeTabClickedText,
  logoClickedText,
  logoutTabClickedText,
  publisherTabClickedText,
  // leaderboardTabClickedText,
} from '../googleAnalytics/GoogleAnalyticsConstants';


function Header() {
  const { data: adminData } = useIsAdminQuery();
  const navigate = useNavigate();
  const location = useLocation(); // Get the current route
  const { instance } = useMsal();

  const [drawerOpen, setDrawerOpen] = useState(false); // State for Drawer

  const openPublisher = () => {
    LogTabEventToGA(publisherTabClickedText);
    navigate('/publisher');
  };

  const handleLogout = async () => {
    try {
      LogTabEventToGA(logoutTabClickedText);
      await instance.logoutPopup({
        postLogoutRedirectUri: '/', // Redirect to the login page after logout
      });
      navigate('/'); // Redirect to the login page
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const toggleDrawer = (open: boolean) => () => {
    LogTabEventToGA(open ? drawerOpenedText : drawerClosedText);
    setDrawerOpen(open);
  };

  useEffect(() => {
    const accounts = instance.getAllAccounts();
    if (!accounts || accounts.length === 0) {
      navigate('/', { replace: true });
    }
  }, [instance, navigate]);

  return (
    <>
      <AppBar
        position="relative"
        elevation={0}
        sx={{
          zIndex: 1000,
          position: 'fixed',
          top: 0,
          width: '100%',
          left: 0,
          right: 0,
          backgroundColor: '#e6e6ec',
          backdropFilter: 'blur(12px)',
          borderBottom: '1px solid rgba(229, 231, 235, 0.7)',
        }}
      >
        <Toolbar sx={{
          justifyContent: 'flex-start',
          minHeight: { xs: '64px', sm: '80px', lg: '90px' },
          maxWidth: '1360px',
          width: '100%',
          margin: '0 auto',
          pl: { xs: 0, sm: 0 },
          pr: { xs: 2, sm: 3 },
          gap: 2,
        }}>
          {/* Logo */}
          <Link to="/home" onClick={() => LogTabEventToGA(logoClickedText)} style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <img src={wiproLogo} alt="Wipro" style={{ height: '48px', cursor: 'pointer' }} />
          </Link>

          {/* Navigation - after logo with gap */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: '4px', alignItems: 'center', ml: 2 }}>
            <Button
              onClick={() => {
                LogTabEventToGA(homeTabClickedText);
                navigate('/home');
              }}
              sx={{
                fontSize: '0.875rem',
                fontWeight: 500,
                color: location.pathname === '/home' ? '#111827' : '#6b7280',
                textTransform: 'none',
                px: 1.5,
                py: 1,
                minWidth: 'auto',
                borderRadius: '6px',
                backgroundColor: 'transparent',
                boxShadow: 'none',
                '&:hover, &:active, &:focus, &.Mui-focusVisible': { backgroundColor: 'transparent', color: '#111827' },
              }}
              disableRipple
              disableFocusRipple
              disableTouchRipple
            >
              Home
            </Button>

            <Button
              onClick={openPublisher}
              sx={{
                fontSize: '0.875rem',
                fontWeight: 500,
                color: location.pathname === '/publisher' ? '#111827' : '#6b7280',
                textTransform: 'none',
                px: 1.5,
                py: 1,
                minWidth: 'auto',
                borderRadius: '6px',
                backgroundColor: 'transparent',
                boxShadow: 'none',
                '&:hover, &:active, &:focus, &.Mui-focusVisible': { backgroundColor: 'transparent', color: '#111827' },
              }}
              disableRipple
              disableFocusRipple
              disableTouchRipple
            >
              Publish
            </Button>

            <Button
              component={Link}
              to="/agent_marketplace"
              onClick={() => LogTabEventToGA(agentsTabClickedText)}
              sx={{
                fontSize: '0.875rem',
                fontWeight: 500,
                color: location.pathname === '/agent_marketplace' ? '#111827' : '#6b7280',
                textTransform: 'none',
                px: 1.5,
                py: 1,
                minWidth: 'auto',
                borderRadius: '6px',
                backgroundColor: 'transparent',
                boxShadow: 'none',
                '&:hover, &:active, &:focus, &.Mui-focusVisible': { backgroundColor: 'transparent', color: '#111827' },
              }}
              disableRipple
              disableFocusRipple
              disableTouchRipple
            >
              Agents
            </Button>
            <Button
              component={Link}
              to="/solutions"
              onClick={() => LogTabEventToGA(appsTabClickedText)}
              sx={{
                fontSize: '0.875rem',
                fontWeight: 500,
                color: location.pathname === '/solutions' ? '#111827' : '#6b7280',
                textTransform: 'none',
                px: 1.5,
                py: 1,
                minWidth: 'auto',
                borderRadius: '6px',
                backgroundColor: 'transparent',
                boxShadow: 'none',
                '&:hover, &:active, &:focus, &.Mui-focusVisible': { backgroundColor: 'transparent', color: '#111827' },
              }}
              disableRipple
              disableFocusRipple
              disableTouchRipple
            >
              Solutions
            </Button>
            {/* <Button
              component={Link}
              to="/leaderboard"
              onClick={() => LogTabEventToGA(leaderboardTabClickedText)}
              sx={{
                fontSize: '0.875rem',
                fontWeight: 500,
                color: location.pathname === '/leaderboard' ? '#111827' : '#6b7280',
                textTransform: 'none',
                px: 1.5,
                py: 1,
                minWidth: 'auto',
                borderRadius: '6px',
                backgroundColor: 'transparent',
                boxShadow: 'none',
                '&:hover, &:active, &:focus, &.Mui-focusVisible': { backgroundColor: 'transparent', color: '#111827' },
              }}
              disableRipple
              disableFocusRipple
              disableTouchRipple
            >
              Leaderboard
            </Button> */}
            {adminData?.is_admin && (
              <Button
                component={Link}
                to="/admin"
                onClick={() => LogTabEventToGA(agentsTabClickedText)}
                sx={{
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  color: location.pathname === '/admin' ? '#111827' : '#6b7280',
                  textTransform: 'none',
                  px: 1.5,
                  py: 1,
                  minWidth: 'auto',
                  borderRadius: '6px',
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                  '&:hover, &:active, &:focus, &.Mui-focusVisible': { backgroundColor: 'transparent', color: '#111827' },
                }}
                disableRipple
                disableFocusRipple
                disableTouchRipple
              >
                Admin
              </Button>
            )}
          </Box>

          {/* Spacer */}
          <Box sx={{ flexGrow: 1 }} />

          {/* Right side - Logout */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
            <IconButton
              onClick={handleLogout}
              sx={{
                color: '#6b7280',
                '&:hover': { backgroundColor: 'rgba(243, 244, 246, 0.8)', color: '#111827' },
              }}
            >
              <LogoutIcon fontSize="small" />
            </IconButton>
          </Box>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ display: { xs: 'block', md: 'none' } }}
            onClick={toggleDrawer(true)} // Open Drawer on click
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Drawer for mobile menu */}
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{
            width: 250,
            padding: '16px', // Add padding inside the drawer
            backgroundColor: '#f5f5f5', // Optional: Light background color for better aesthetics
          }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <List sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <ListItem
              component={Button}
              onClick={() => {
                LogTabEventToGA(homeTabClickedText);
                navigate('/home');
              }}
              sx={{
                borderRadius: '8px', // Rounded corners
                '&:hover': { backgroundColor: '#e0e0e0' }, // Hover effect
              }}
            >
              <ListItemText primary="Home" />
            </ListItem>
            <ListItem
              component={Button}
              onClick={() => {
                LogTabEventToGA(publisherTabClickedText);
                navigate('/publisher');
              }}
              sx={{
                borderRadius: '8px',
                '&:hover': { backgroundColor: '#e0e0e0' },
              }}
            >
              <ListItemText primary="Publisher" />
            </ListItem>
            <ListItem
              component={Button}
              onClick={() => {
                LogTabEventToGA(agentsTabClickedText);
                navigate('/agent_marketplace');
              }}
              sx={{
                borderRadius: '8px',
                '&:hover': { backgroundColor: '#e0e0e0' },
              }}
            >
              <ListItemText primary="Agents" />
            </ListItem>
            {/* <ListItem
              component={Button}
              onClick={() => {
                LogTabEventToGA(leaderboardTabClickedText);
                navigate('/leaderboard');
              }}
              sx={{
                borderRadius: '8px',
                '&:hover': { backgroundColor: '#e0e0e0' },
              }}
            >
              <ListItemText primary="Leaderboard" />
            </ListItem> */}
            <ListItem
              component={Button}
              onClick={handleLogout}
              sx={{
                borderRadius: '8px',
                '&:hover': { backgroundColor: '#e0e0e0' },
              }}
            >
              <ListItemText primary="Logout" />
            </ListItem>
            {adminData?.is_admin && (
              <ListItem
                component={Button}
                onClick={() => {
                  LogTabEventToGA(agentsTabClickedText);
                  navigate('/admin');
                }}
                sx={{
                  borderRadius: '8px',
                  '&:hover': { backgroundColor: '#e0e0e0' },
                }}
              >
                <ListItemText primary="Admin" />
              </ListItem>
            )}
          </List>
        </Box>
      </Drawer>
    </>
  );
}

export default Header;
